import React from 'react';
import { useTranslation } from 'react-i18next';

import { CONFIG } from 'config';
import { RouterHistoryProvider as RHP } from 'providers';

import { PagesRoutes } from './PagesRoutes';

export function Pages(props) {
    const { t } = useTranslation('pages');

    // Redirects for older hash routes in matchmaking app
    // Must keep this working for backwards compatibility
    if (
        window.location.hash.indexOf('#/share/') === 0 ||
        window.location.hash.indexOf('#/referral/') === 0
    ) {
        const buildURL = `${CONFIG.appLinks.matchmaking}/${window.location.hash}`;
        const redirURL = encodeURIComponent(buildURL);
        // Redirect to the a new URL
        RHP.replace(`/iframe/${redirURL}`);
        return null;
    }

    return <PagesRoutes t={t} />;
}
export default Pages;
